import AppHeader from '../../components/app-header';
import MainPageNavigator from '../../navigator/main-page';
import './index.css';
import { Outlet } from 'react-router-dom';

function MainPage(): JSX.Element {
  return (
    <div className='main_root'>
      <AppHeader />
      <div className='main_content'>
        <MainPageNavigator />
        <Outlet />
      </div>
    </div>
  );
}

export default MainPage;
